
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import draggable from 'vuedraggable';
import { DataTableHeader } from 'vuetify';
import { BaseProfileDataInterface } from '@/services/Users-profile/interfaces';
import { RepeatableEventsInterface } from '@/services/Calendar/RepeatableEvents/Interfaces';
import DeleteRepeatableEventDialog from '@/components/dialogs/calendar/events/DeleteRepeatableEventDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    draggable,
    DeleteRepeatableEventDialog: DeleteRepeatableEventDialog,
  },
  inject: [
    'repeatableEventsRepository',
  ],
})
export default class RepeatableEventsComponent extends Vue {
  @Prop() private repeatableEvents!: RepeatableEventsInterface[];
  @Prop() private usersMap!: { [userId: string]: BaseProfileDataInterface };

  private headers: DataTableHeader[] = [
    { text: 'Name', value: 'name' },
    { text: 'With Attendance', value: 'withAttendance' },
    { text: 'Repeat Type', value: 'repeatEvery' },
    { text: 'Author', value: 'author' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];
  private deleteRepeatableEventDialogData: RepeatableEventsInterface | false = false;
  private deleteRepeatableEventDialog: string = '';
  private repeatType: string[] = [
    'Weekly',
    'Once Every Other Week',
    'Week Custom',
    'Monthly',
    'Yearly',
  ]

  private search: string = '';

  private getRepeatType(type: number): string {
    return this.repeatType[type];
  }

  private createRepeatableEvent(): void {
    this.$router.push({ name: 'calendar_crate_repeatable_event' });
  }

  private editRepeatableEvent(event: RepeatableEventsInterface): void {
    this.$router.push({ name: 'calendar_edit_repeatable_event', params: { eventId: String(event.id) } });
  }

  private deleteRepeatableEvent(event: RepeatableEventsInterface): void {
    this.deleteRepeatableEventDialogData = event;
    this.deleteRepeatableEventDialog = 'delete-repeatable-event-dialog';
  }

  private filterRepeatableEvents(id: number): void {
    this.$emit('filter-repeatable-events', id);
  }
}
